export enum ContentType {
    news,
    event
}